import { ListBoxItemProps } from "react-aria-components";
import { ReactNode } from "react";

export interface MDSListBoxItemProps extends Omit<ListBoxItemProps, "children"> {
  children?: ReactNode;
  leftAddon?: ReactNode | null;
  rightAddon?: ReactNode | null;
}

// Add enum for slots
export enum MDSListBoxSlotName {
  LeftAddon = "left-addon",
  RightAddon = "right-addon",
}
